module.exports = {"pathContext":{"name":"CensusKennelStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"CLEAN"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DIRTY"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DO_NOT_USE"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"STORAGE"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-census-kennel-status.json
// module id = 1220
// module chunks = 275134419026451